/**
 * [INPUT]: 无
 * [OUTPUT]: 对外提供 TIER_HEX（tier token → hex）与 tierHex(total)
 * [POS]: apps/web/report 的 tier 色源，供 Canvas 渲染（Canvas 不能用 Tailwind token）；与 tailwind.config 保持同色
 * [PROTOCOL]: 变更时更新此头部，然后检查 ../../CLAUDE.md
 */
import { tierOf } from '../scorer'

// 与 apps/web/tailwind.config.ts 的 tier.* 同色
export const TIER_HEX: Record<string, string> = {
  'tier-gray': '#D98863',   // Subhuman -> 暖陶土色
  'tier-slate': '#D98863',  // Below Average -> 暖陶土色
  'tier-blue': '#E8A34D',   // Normie -> 琥珀色
  'tier-cyan': '#E8A34D',   // High Normie -> 琥珀色
  'tier-green': '#8FB56B',  // HTN -> 柔和橄榄绿
  'tier-yellow': '#C5AA73', // Chadlite -> LUME黄铜金
  'tier-orange': '#C5AA73', // Chad -> LUME黄铜金
  'tier-red': '#8FB56B',    // Adam / Eve -> 柔和橄榄绿
}

export function tierHex(total: number): string {
  return TIER_HEX[tierOf(total).color] ?? '#94a3b8'
}